// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a {
  text-decoration: none;
}

.link {
  cursor: pointer;
  color: #5c69f9;
}
.link:hover {
  text-decoration: underline;
}

.text-gradient-intel {
  font-weight: bold;
  background: #CE4F8C;
  background: linear-gradient(to right, #CE4F8C 0%, #4720E2 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.text-xs {
  font-size: 0.75rem; /* 12px */
  line-height: 1rem; /* 16px */
}
.text-sm {
  font-size: 0.875rem; /* 14px */
  line-height: 1.25rem;
}
.text-base {
  font-size: 1rem; /* 16px */
  line-height: 1.5rem; /* 24px */
}
.text-lg {
  font-size: 1.125rem; /* 18px */
  line-height: 1.75rem; /* 28px */
}
@media only screen and (max-width: 450px) {
  .text-lg {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.text-xl {
  font-size: 1.25rem; /* 20px */
  line-height: 1.75rem; /* 28px */
}
@media only screen and (max-width: 450px) {
  .text-xl {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.text-leading {
  line-height: 1.7rem;
}
@media only screen and (max-width: 450px) {
  .text-leading {
    line-height: 1.5rem;
  }
}

.SearchMainBody .borderBottom {
  border-bottom: 1px solid var(--color-paper-600);
}
.SearchMainBody table {
  width: 100%;
  table-layout: fixed;
}
.SearchMainBody table.main {
  color: var(--color-white-500);
}
.SearchMainBody table.main > tbody {
  vertical-align: top;
  font-size: 14px;
}
.SearchMainBody table.main > tbody .is_active + .is_active > td {
  border-top: 2px solid var(--color-paper-500) !important;
}
.SearchMainBody table.main > tbody tr {
  vertical-align: middle;
}
.SearchMainBody table.main > tbody tr:not(.noHover):hover > td {
  cursor: pointer;
  background-color: var(--color-paper-600);
}
.SearchMainBody table.main > tbody tr:not(:last-child) > td {
  border-bottom: 1px solid var(--color-paper-600);
}
.SearchMainBody table.main > tbody tr.is_active > td {
  background-color: var(--color-paper-600);
}
.SearchMainBody table.main > tbody tr.is_extendable.is_active td:last-child:after {
  transform: rotate(180deg);
}
.SearchMainBody table.main > tbody tr.is_extendable td:last-child {
  position: relative;
}
.SearchMainBody thead th {
  padding: 0.3rem 0.55rem;
  border-bottom: 1px solid var(--color-paper-600);
}
.SearchMainBody tfoot td {
  padding: 0.75rem;
  border-top: 1px solid var(--color-paper-600);
}
.SearchMainBody thead th, .SearchMainBody tfoot td {
  font-weight: normal;
  font-size: 13px;
  color: var(--color-gray-400);
}

.SearchMainFilter {
  height: 100%;
  overflow-y: auto;
  padding-bottom: 35px;
}
.SearchMainFilter li {
  color: var(--color-white-500);
  font-size: 15px;
  position: relative;
  border-radius: 10px;
  min-height: fit-content;
}
.SearchMainFilter li .content-title {
  display: flex;
  padding: 8px;
  cursor: pointer;
}
.SearchMainFilter li.is_active {
  font-weight: 600;
  color: var(--color-primary-500);
  background-color: var(--color-primary-700);
}
.SearchMainFilter li.is_open {
  color: var(--color-white-500);
  border-bottom-color: var(--color-paper-400);
  background-color: var(--color-gray-700);
}
.SearchMainFilter li.is_open:after {
  transform: rotate(180deg);
  border-top-color: var(--color-primary-500);
}
.SearchMainFilter .range-picker-custom {
  width: 100%;
  background-color: var(--color-paper-400);
  color: var(--color-white-500);
  border: 1px solid var(--color-gray-700);
}
.SearchMainFilter .ant-picker-separator, .SearchMainFilter .ant-picker-suffix, .SearchMainFilter .ant-picker-clear {
  color: var(--color-white-500) !important;
}
.SearchMainFilter .ant-picker input::placeholder {
  color: var(--color-gray-300) !important;
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/theme/_typography.scss","webpack://./src/components/modules/SearchMain/index.scss","webpack://./src/assets/scss/_breakpoint.scss"],"names":[],"mappings":"AAOA;EACI,qBAAA;ACNJ;;ADQA;EACI,eAAA;EACA,cAAA;ACLJ;ADMI;EACE,0BAAA;ACJN;;ADQA;EACI,iBAAA;EACA,mBAAA;EACA,+DAAA;EACA,qBAAA;EACA,6BAAA;EACA,oCAAA;ACLJ;;ADQI;EACI,kBAAA,EAAA,SAAA;EACA,iBAAA,EAAA,SAAA;ACLR;ADOI;EACI,mBAAA,EAAA,SAAA;EACA,oBAAA;ACLR;ADOI;EACI,eAAA,EAAA,SAAA;EACA,mBAAA,EAAA,SAAA;ACLR;ADOI;EACI,mBAAA,EAAA,SAAA;EACA,oBAAA,EAAA,SAAA;ACLR;ACnCE;EFsCE;IAIQ,eAAA;IACA,mBAAA;ECHV;AACF;ADKI;EACI,kBAAA,EAAA,SAAA;EACA,oBAAA,EAAA,SAAA;ACHR;AC7CE;EF8CE;IAIQ,eAAA;IACA,mBAAA;ECDV;AACF;ADGI;EACI,mBAAA;ACDR;ACtDE;EFsDE;IAGQ,mBAAA;ECCV;AACF;;AAzDI;EACI,+CAAA;AA4DR;AA1DI;EACI,WAAA;EACA,mBAAA;AA4DR;AA3DQ;EACI,6BAAA;AA6DZ;AA5DY;EACI,mBAAA;EACA,eAAA;AA8DhB;AA7DgB;EACI,uDAAA;AA+DpB;AA7DgB;EACI,sBAAA;AA+DpB;AA9DoB;EACI,eAAA;EACA,wCAAA;AAgExB;AA9DoB;EACI,+CAAA;AAgExB;AA7DoB;EACI,wCAAA;AA+DxB;AA5DwB;EAAkC,yBAAA;AA+D1D;AA9DwB;EACI,kBAAA;AAgE5B;AAxDI;EACI,uBAAA;EACA,+CAAA;AA0DR;AAxDI;EAAW,gBAAA;EAAkB,4CAAA;AA4DjC;AA3DI;EACI,mBAAA;EACA,eAAA;EACA,4BAAA;AA6DR;;AA1DA;EACI,YAAA;EACA,gBAAA;EACA,oBAAA;AA6DJ;AA3DI;EACI,6BAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EAEA,uBAAA;AA4DR;AA3DQ;EACI,aAAA;EACA,YAAA;EACA,eAAA;AA6DZ;AA3DQ;EACI,gBAAA;EACA,+BAAA;EACA,0CAAA;AA6DZ;AA3DQ;EACI,6BAAA;EACA,2CAAA;EACA,uCAAA;AA6DZ;AA5DY;EACI,yBAAA;EACA,0CAAA;AA8DhB;AA1DI;EACI,WAAA;EACA,wCAAA;EACA,6BAAA;EACA,uCAAA;AA4DR;AA1DI;EACI,wCAAA;AA4DR;AA1DI;EACI,uCAAA;EACA,UAAA;AA4DR","sourcesContent":["@use \"../breakpoint\" as *;\n@use \"../colors\" as *;\n\n@mixin textShadow() {\n    text-shadow: 2px 2px 2px $color-gradient-black-500;\n}\n\na {\n    text-decoration: none;\n}\n.link {\n    cursor: pointer;\n    color: #5c69f9;\n    &:hover{\n      text-decoration: underline;\n    }\n}\n\n.text-gradient-intel {\n    font-weight: bold;\n    background: #CE4F8C;\n    background: linear-gradient(to right, #CE4F8C 0%, #4720E2 100%);\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n}\n.text {\n    &-xs {\n        font-size: 0.75rem; /* 12px */\n        line-height: 1rem; /* 16px */\n    }\n    &-sm {\n        font-size: 0.875rem; /* 14px */\n        line-height: 1.25rem;\n    }\n    &-base {\n        font-size: 1rem; /* 16px */\n        line-height: 1.5rem; /* 24px */\n    }\n    &-lg {\n        font-size: 1.125rem; /* 18px */\n        line-height: 1.75rem; /* 28px */\n        @include mobile {\n            font-size: 1rem;\n            line-height: 1.5rem;\n        }\n    }\n    &-xl {\n        font-size: 1.25rem; /* 20px */\n        line-height: 1.75rem; /* 28px */\n        @include mobile {\n            font-size: 1rem;\n            line-height: 1.5rem;\n        }\n    }\n    &-leading {\n        line-height: 1.7rem;\n        @include mobile {\n            line-height: 1.5rem; \n        }\n    }\n}","@use \"../../../assets/scss/theme/typography\" as *;\n\n.SearchMainBody {\n    .borderBottom {\n        border-bottom: 1px solid var(--color-paper-600);\n    }\n    table {\n        width: 100%;\n        table-layout: fixed;\n        &.main {\n            color: var(--color-white-500); \n            > tbody {\n                vertical-align: top;\n                font-size: 14px;\n                .is_active + .is_active > td {\n                    border-top: 2px solid var(--color-paper-500) !important;\n                }\n                tr {\n                    vertical-align: middle;\n                    &:not(.noHover):hover > td {\n                        cursor: pointer;\n                        background-color: var(--color-paper-600);\n                    }\n                    &:not(:last-child) > td {\n                        border-bottom: 1px solid var(--color-paper-600);\n                    }\n                   \n                    &.is_active > td {\n                        background-color: var(--color-paper-600);\n                    }\n                    &.is_extendable {\n                        &.is_active td:last-child:after { transform: rotate(180deg); }\n                        td:last-child {\n                            position: relative;\n                           \n                        }\n                    }\n                }\n            }\n        }\n    }\n    thead th { \n        padding: .3rem 0.55rem; \n        border-bottom: 1px solid var(--color-paper-600); \n    }\n    tfoot td { padding: 0.75rem; border-top: 1px solid var(--color-paper-600); }\n    thead th, tfoot td {\n        font-weight: normal;\n        font-size: 13px;\n        color: var(--color-gray-400);\n    }\n}\n.SearchMainFilter {\n    height: 100%;\n    overflow-y: auto;\n    padding-bottom: 35px;\n  \n    li {\n        color: var(--color-white-500);\n        font-size: 15px;\n        position: relative;\n        border-radius: 10px;\n        // height: 38px;\n        min-height: fit-content;\n        .content-title {\n            display: flex;\n            padding: 8px;\n            cursor: pointer;\n        }\n        &.is_active {\n            font-weight:600;\n            color: var(--color-primary-500);\n            background-color: var(--color-primary-700);\n        }\n        &.is_open {\n            color: var(--color-white-500);\n            border-bottom-color: var(--color-paper-400);\n            background-color: var(--color-gray-700);\n            &:after {\n                transform: rotate(180deg);\n                border-top-color: var(--color-primary-500);\n            }\n        }\n    }\n    .range-picker-custom {\n        width: 100%;\n        background-color: var(--color-paper-400);\n        color: var(--color-white-500);\n        border: 1px solid var(--color-gray-700);\n    }\n    .ant-picker-separator, .ant-picker-suffix, .ant-picker-clear{\n        color: var(--color-white-500) !important; \n    }\n    .ant-picker input::placeholder{\n        color: var(--color-gray-300) !important; \n        opacity: 1; \n    }\n}","@mixin mobile {\n  @media only screen and (max-width: 450px) {\n    @content;\n  }\n}\n\n@mixin mobileH {\n  @media only screen and (max-height: 710px) {\n    @content;\n  }\n}\n\n@mixin tablet {\n  @media only screen and (max-width: 810px) {\n    @content;\n  }\n}\n\n@mixin middle {\n  @media only screen and (max-width: 576px) {\n    @content;\n  }\n}\n\n@mixin middleTablet {\n  @media only screen and (max-width: 780px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
